/** @format */

import {CalcMethod, WidgetSettings} from 'components/PropertyWidget/model';
import {DEFAULT_CALC_METHOD} from 'pages/Home/DigitalCast/constants/common';

const getCalcMethod = (widgetSettings?: WidgetSettings): CalcMethod | undefined => {
  const savedCalcMethod = widgetSettings?.calcMethod || DEFAULT_CALC_METHOD;
  // Сравнение с none нужно для обратной совместимости с предыдущей реализацией. Не удалять!
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  if (savedCalcMethod === 'none') {
    return undefined;
  }
  return savedCalcMethod;
};

export {getCalcMethod};
